export default {
  name: 'jobs',
  components: {},
  props: [],
  data() {
    return {}
  },
  computed: {
    jobs() {
      return this.$store.state.jobs
    }
  },
  mounted() {

  },
  methods: {

  }
}